import { A as AffixIconWithTrailing } from './affix.js';
import { V as VividElement, o as observable, a as attr, v as volatile } from './vivid-element.js';
import { H as HostSemantics } from './host-semantics.js';
import { i as isHTMLElement } from './dom.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
function isListboxOption(el) {
  return isHTMLElement(el) && (el.getAttribute("role") === "option" || el instanceof HTMLOptionElement);
}
class ListboxOption extends HostSemantics(
  AffixIconWithTrailing(VividElement)
) {
  constructor(text, value, defaultSelected, selected) {
    super();
    this.defaultSelected = false;
    /**
     * Tracks whether the "selected" property has been changed.
     * @internal
     */
    this.dirtySelected = false;
    // eslint-disable-next-line @repo/repo/no-attribute-default-value
    this.value = "";
    this._highlighted = false;
    this._displayCheckmark = false;
    this._vvdSearchText = "";
    this._isNotMatching = false;
    if (text) {
      this.text = text;
    }
    if (value) {
      this.value = value;
    }
    if (defaultSelected) {
      this.defaultSelected = defaultSelected;
    }
    if (selected) {
      this.selected = selected;
    }
    this.proxy = new Option(
      this.text,
      this.value,
      this.defaultSelected,
      this.selected
    );
    this.proxy.disabled = this.disabled;
  }
  defaultSelectedChanged() {
    if (!this.dirtySelected) {
      this.selected = this.defaultSelected;
      if (this.proxy instanceof HTMLOptionElement) {
        this.proxy.selected = this.defaultSelected;
      }
    }
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.defaultSelected = this.defaultSelected;
    }
  }
  disabledChanged() {
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.disabled = this.disabled;
    }
  }
  /**
   * @deprecated Use `defaultSelected` instead.
   */
  get selectedAttribute() {
    return this.defaultSelected;
  }
  set selectedAttribute(value) {
    this.defaultSelected = value;
  }
  selectedChanged() {
    if (!this.dirtySelected) {
      this.dirtySelected = true;
    }
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.selected = this.selected;
    }
  }
  valueChanged() {
    if (typeof this.value !== "string") {
      this.value = "";
      return;
    }
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.value = this.value;
    }
  }
  get label() {
    return this._label ?? this.text;
  }
  set label(value) {
    this._label = value;
  }
  set text(value) {
    this._text = value;
  }
  get text() {
    return this._text ?? "";
  }
  get form() {
    return null;
  }
  get _hasMatchedText() {
    return Boolean(this.matchedText ?? this._vvdSearchText);
  }
  get _matchedRange() {
    const matchedText = this.matchedText ?? this._vvdSearchText;
    if (matchedText) {
      const matchIndex = this.text.toLowerCase().indexOf(matchedText.toLowerCase());
      return matchIndex === -1 ? { from: 0, to: 0 } : {
        from: matchIndex,
        to: matchIndex + matchedText.length
      };
    }
    return { from: 0, to: 0 };
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback();
    if (!this.dirtySelected) {
      this.selected = this.defaultSelected;
      this.dirtySelected = false;
    }
  }
}
__decorateClass([
  observable
], ListboxOption.prototype, "checked", 2);
__decorateClass([
  attr({ attribute: "selected", mode: "boolean" })
], ListboxOption.prototype, "defaultSelected", 2);
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ mode: "boolean" })
], ListboxOption.prototype, "disabled", 2);
__decorateClass([
  attr({ attribute: "current-selected", mode: "boolean" })
], ListboxOption.prototype, "selected", 2);
__decorateClass([
  attr({ attribute: "value" })
], ListboxOption.prototype, "value", 2);
__decorateClass([
  attr({
    attribute: "label"
  })
], ListboxOption.prototype, "_label", 2);
__decorateClass([
  attr({
    attribute: "text"
  })
], ListboxOption.prototype, "_text", 2);
__decorateClass([
  observable
], ListboxOption.prototype, "_highlighted", 2);
__decorateClass([
  observable
], ListboxOption.prototype, "_displayCheckmark", 2);
__decorateClass([
  attr({ attribute: "matched-text" })
], ListboxOption.prototype, "matchedText", 2);
__decorateClass([
  observable
], ListboxOption.prototype, "_vvdSearchText", 2);
__decorateClass([
  volatile
], ListboxOption.prototype, "_hasMatchedText", 1);
__decorateClass([
  observable
], ListboxOption.prototype, "_isNotMatching", 2);
__decorateClass([
  volatile
], ListboxOption.prototype, "_matchedRange", 1);
__decorateClass([
  attr({ attribute: "tag-connotation" })
], ListboxOption.prototype, "tagConnotation", 2);

export { ListboxOption as L, isListboxOption as i };
